import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { ToastContainer, notify } from '../../libraries/notifications';
import { history } from "../../routes";
import config from "../../config";

import { isEmptyObject, getObjectWithJsonDataToFormValues, cancelValidation, startValidation, isObject } from '../../libraries/utils';

import Cover from '../../components/commons/Cover';
import Avatar from '../../components/commons/Avatar';
import LayoutSmall from "../../components/layout/LayoutSmall";
import Button from "../../components/commons/Button";
import Icon from '../../libraries/icons';
import Swal from 'sweetalert2';

import appointmentsActions from "../../context/appointments/actions";

class MyAppointment extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      appointment: null
    };
  }

  componentDidMount() {
    const params = this.props.match.params;
    if (params.id) {
      this.getAppointments(params.id);
      const state = this.props.location.state;
      this.setState({ route: !isEmptyObject(state) ? state.from : config.ROUTES.APPOINTMENTS.LIST });      
    } else {
      history.push(config.ROUTES.APPOINTMENTS.LIST);
    }
  }

  getAppointments = async (id) => {
    await this.props.onGet(id);
    const { appointment } = this.props;
    if (appointment.error) {
      notify(this.t(appointment.error.message));
    } else {
      const appointmentData = getObjectWithJsonDataToFormValues(
        appointment.item,
        ['id', 'time', 'date', 'sub_type', 'status', 'professional', 'location', 'time_slot']
      );
      this.setState({ appointment: appointmentData });
    }
  };

  gotoBack = () => {
    history.push(this.state.route);
  }

  updateStatus = async () => {
    const payload = {
      id: this.state.appointment.id,
      status: config.TRANSACTIONS.BOOK.STATUS.IN_PROGRESS,
    }
    await this.props.onSaveOrUpdate(payload);
    const error = this.props.appointment.error;
    if (error) {
      notify(this.t(error.message));
    } 
  };

  onCancel = () => {
    Swal.fire({
      title: this.t("¿Are you sure?"),
      text: this.t("¿Seguro que desea cancelar el turno?"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.t("Yes"),
      cancelButtonText: this.t("No"),
    })
    .then((result) => {
      if (result.isConfirmed) {
        const payload = {
          id: this.state.appointment.id,
          status: config.TRANSACTIONS.BOOK.STATUS.CANCELED,
        }
        this.props.onSaveOrUpdate(payload).then(() => {
          history.push({
            pathname: config.ROUTES.APPOINTMENTS.SUCCESS.replace(':id', this.state.appointment.id),
            state: {
              title: "Consulta cancelada con éxito",
              button:{
                text: "Volver a consultas",
                route: config.ROUTES.APPOINTMENTS.LIST,
              },
              button2:{
                text: "Home",
                route: config.ROUTES.HOME,
              }
            }
          })
        })
        
      }
    });
   
  }

  onGoCall = async () => {
    await this.updateStatus()
    history.push(config.ROUTES.APPOINTMENTS.CALL.replace(':id', this.state.appointment.id))
  }

  render() {
    const { appointment } = this.state
    const { professional, time, date, time_slot, status } = appointment || {};
    
    const types = (type) => {
      return config.APPOINTMENTS.filter((f) => f.type === type)[0] || {};
    }
    let finish_time =  time ? `${time[0]}${parseInt(time.split("")[1])+1}${time.substr(2)}` : 0
    finish_time = time_slot ? time_slot.end_time : finish_time
    //if(time_slot) console.log("data", data.time_slot)
    const day = new Date(date)
    
    const [ specialty1, specialty2 ] = professional ? professional.specialty.split("_/_/_") : ["",""]
    const specialtyString = (specialty1 ?? "") + " - " + (specialty2 ?? "")

    return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: this.t("Consulta profesional"),
          className: "!bg-transparent fixed z-10 text-primary-content",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
        loading={this.props.appointment.loading}
      >
        <ToastContainer/>
        { !this.props.appointment.loading && appointment && (
          <>
            <Cover image={professional.cover_image} />
            <section className="section-card">
              <div className="flex flex-col place-items-center mb-4 border-b pb-4">
                <Avatar
                  image={professional.profile_image}
                  label={professional.name}
                  className="rounded-full w-28 h-28"
                  containerClassName="-mt-10 z-20 border-white border-8 mb-3"
                />
                <h1 className="text-primary">{professional.first_name} {professional.last_name}</h1>
                <small>{specialtyString} </small>
              </div>

              <h2>{this.t("Información de la consulta")}</h2>
              <div className="grid grid-cols-3 gap-3 mt-3">
                <div className="card white p-4 text-center">
                  <Icon className="w-12 text-success mx-auto mb-2" name={types(appointment.sub_type).icon} />
                  <small className="text-gray-500">{this.t(types(appointment.sub_type).label)}</small>
                </div>
                {appointment.sub_type !== config.TRANSACTIONS.BOOK.SUB_TYPE.VIDEO && 
                 appointment.sub_type !== config.TRANSACTIONS.BOOK.SUB_TYPE.MESSAGE && (
                  <div className="card white p-4 text-center">
                    <Icon className="w-12 text-success mx-auto mb-2" name="location_marker" />
                    <small className="text-gray-500">{isObject(appointment.location) ? appointment.location.name : appointment.location}</small>
                  </div>
                )}
                <div className="card white p-4 text-center">
                  <Icon className="w-12 text-success mx-auto mb-2" name="clock" />
                  <small className="text-gray-500">{date && day.toLocaleDateString()} {time} - {finish_time}</small>
                </div>
              </div>
              {(status === config.TRANSACTIONS.BOOK.STATUS.BOOKED || status === config.TRANSACTIONS.BOOK.STATUS.IN_PROGRESS) && <>
                <div className="grid grid-cols-2 gap-3 mt-10">
                  <Button className="btn-error btn-block uppercase text-white" title={this.t("Cancelar")}
                    onClick={this.onCancel}
                    disabled={!cancelValidation(appointment.date)}
                  />
                  <Button className="btn-primary btn-block uppercase" title={this.t("Ir a consulta")}
                    onClick={this.onGoCall}
                    disabled={!startValidation(appointment.date) || !(appointment.sub_type === config.TRANSACTIONS.BOOK.SUB_TYPE.VIDEO)}
                  />
                </div>
              </>}
              
            </section>
          </>                    
        )}
      </LayoutSmall>
    ) 
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.users.auth,
    appointment: state.appointments.current,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGet: (params) => dispatch(appointmentsActions.get(params)),
    onSaveOrUpdate: (params) => dispatch(appointmentsActions.saveOrUpdate(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MyAppointment));